import { MultiUserActionTypes } from './actions';
import Constants from './constants';
import { processUsersFile } from './utils';

export const initialState = {
  availableSubscriptions: [],
  isFetchingAvailableSubscription: false,

  isMultiAssignProcess: false,
  multiAssignProcessStatus: null,
  isMultiAssignProcessCompleted: false,

  purchasedSubscription: null,

  isUploadingUsersFile: false,
  uploadingUsersFileLastStatus: null,
  usersFile: null,
};

export const ACTION_HANDLERS = {
  [MultiUserActionTypes.UPLOAD_USERS_FILE_COMPLETED]: (state, action) => {
    const processedFile = processUsersFile(action.payload.file);
    return Object.assign({}, state, {
      isUploadingUsersFile: false,
      uploadingUsersFileLastStatus: null,
      usersFile: {
        ...processedFile,
      },
    });
  },
  [MultiUserActionTypes.UPLOAD_USERS_FILE_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isUploadingUsersFile: false,
      uploadingUsersFileLastStatus: action.payload.status,
    }),
  [MultiUserActionTypes.UPLOAD_USERS_FILE_WAITING]: state =>
    Object.assign({}, state, {
      isUploadingUsersFile: true,
    }),

  [MultiUserActionTypes.ASSIGN_MULTI_USERS_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      isMultiAssignProcess: false,
      multiAssignProcessStatus: null,
      isMultiAssignProcessCompleted: true,
      users: action.payload.users,
    }),
  [MultiUserActionTypes.ASSIGN_MULTI_USERS_FAILURE]: (state, action) =>
    Object.assign({}, state, {
      isMultiAssignProcess: false,
      multiAssignProcessStatus: action.payload.status,
    }),
  [MultiUserActionTypes.ASSIGN_MULTI_USERS_WAITING]: (state, action) =>
    Object.assign({}, state, {
      isMultiAssignProcess: true,
      multiAssignProcessStatus: action.payload.status,
    }),

  [MultiUserActionTypes.USERS_LIST_VALIDATION_FINISHED]: (state, action) =>
    Object.assign({}, state, {
      isMultiAssignProcess: false,
      multiAssignProcessStatus: action.payload.status,
    }),
  [MultiUserActionTypes.USERS_LIST_VALIDATION_WAITING]: (state, action) =>
    Object.assign({}, state, {
      isMultiAssignProcess: true,
      multiAssignProcessStatus: action.payload.status,
    }),

  [MultiUserActionTypes.UPDATE_PURCHASE_SUBSCRIPTION_TYPE]: (state, action) =>
    Object.assign({}, state, {
      purchasedSubscription: `${action.payload.type}_${action.payload.period}`,
    }),

  [MultiUserActionTypes.NOTIFICATION_PROCESS]: (state, action) =>
    Object.assign({}, state, {
      multiAssignProcessStatus: action.payload.notification,
    }),
  [MultiUserActionTypes.FETCH_AVAILABLE_SUBSCRIPTIONS_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      availableSubscriptions: action.payload.subscriptions,
      isFetchingAvailableSubscription: false,
    }),
  [MultiUserActionTypes.FETCH_AVAILABLE_SUBSCRIPTIONS_FAILED]: state =>
    Object.assign({}, state, {
      isFetchingAvailableSubscription: false,
      availableSubscriptions: [],
    }),
  [MultiUserActionTypes.FETCH_AVAILABLE_SUBSCRIPTIONS_WAITING]: state =>
    Object.assign({}, state, {
      isFetchingAvailableSubscription: true,
    }),
};

export function appReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export default {
  name: Constants.MODULE_NAME,
  reducer: appReducer,
};
